<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          CEP Properties
        </template>
        <template #actions v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button" 
                  @keypress.enter.prevent="editPanel()"
                  @click="editPanel()"
                  :class="{ disabled: editOtherPanels }"
                  v-if="!editCurrentPanel"
                  :tabindex="editOtherPanels ? -1 : 0"
                >
                  <font-awesome-icon :icon="['far', 'edit']" size="lg" title="Edit" />
                </a>
              </div>
            </li>
          </ul>
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <es-form style="padding: 1.15rem 0rem">
        <template #es-form>
          <table>
            <tbody>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Population: Submission Open Date
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      v-if="editCurrentPanel"
                      class="input calendar has-text-right"
                      :class="{ 'placeholder': !form.POPULATION_SUBMISSION_OPEN_DATE,
                        'is-danger' : errPopOpenDate }"
                      type="date"
                      @change.prevent="checkField('POPULATION_SUBMISSION_OPEN_DATE')"
                      v-model="form.POPULATION_SUBMISSION_OPEN_DATE"
                      :aria-label="form.POPULATION_SUBMISSION_OPEN_DATE"
                    />
                    <span v-else class="has-text-right is-pulled-right">
                      {{ formatDate(form.POPULATION_SUBMISSION_OPEN_DATE) }}
                    </span>
                    <span v-if="errPopOpenDate" class="help is-danger">
                      {{ msgPopOpenDate }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Population: Submission Due Date
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      v-if="editCurrentPanel"
                      class="input calendar has-text-right"
                      :class="{ 'placeholder': !form.POPULATION_SUBMISSION_DUE_DATE,
                        'is-danger' : errPopDueDate }"
                      type="date"
                      @change.prevent="checkField('POPULATION_SUBMISSION_DUE_DATE')"
                      v-model="form.POPULATION_SUBMISSION_DUE_DATE"
                      :aria-label="form.POPULATION_SUBMISSION_DUE_DATE"
                    />
                    <span v-else class="has-text-right is-pulled-right">
                      {{ formatDate(form.POPULATION_SUBMISSION_DUE_DATE) }}
                    </span>
                    <span v-if="errPopDueDate" class="help is-danger">
                      {{ msgPopDueDate }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Elections: Submission Due Date
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      v-if="editCurrentPanel"
                      class="input calendar has-text-right"
                      :class="{ 'placeholder': !form.ELECTION_SUBMISSION_DUE_DATE,
                        'is-danger' : errElecDueDate }"
                      type="date"
                      @change.prevent="checkField('ELECTION_SUBMISSION_DUE_DATE')"
                      v-model="form.ELECTION_SUBMISSION_DUE_DATE"
                      :aria-label="form.ELECTION_SUBMISSION_DUE_DATE"
                    />
                    <span v-else class="has-text-right is-pulled-right">
                      {{ formatDate(form.ELECTION_SUBMISSION_DUE_DATE) }}
                    </span>
                    <span v-if="errElecDueDate" class="help is-danger">
                      {{ msgElecDueDate }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Enrollment Cut-Off Date
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      v-if="editCurrentPanel"
                      class="input calendar has-text-right"
                      :class="{ 'placeholder': !form.ENROLLMENT_CUTOFF_DATE,
                        'is-danger' : errEnrollCutOffDate }"
                      type="date"
                      @change.prevent="checkField('ENROLLMENT_CUTOFF_DATE')"
                      v-model="form.ENROLLMENT_CUTOFF_DATE"
                      :aria-label="form.ENROLLMENT_CUTOFF_DATE"
                    />
                    <span v-else class="has-text-right is-pulled-right">
                      {{ formatDate(form.ENROLLMENT_CUTOFF_DATE) }}
                    </span>
                    <span v-if="errEnrollCutOffDate" class="help is-danger">
                      {{ msgEnrollCutOffDate }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }">
                  Population Cut-Off Date
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      v-if="editCurrentPanel"
                      class="input calendar has-text-right"
                      :class="{ 'placeholder': !form.POPULATION_CUTOFF_DATE,
                        'is-danger' : errPopulationCutOffDate }"
                      type="date"
                      @change.prevent="checkField('POPULATION_CUTOFF_DATE')"
                      v-model="form.POPULATION_CUTOFF_DATE"
                      :aria-label="form.POPULATION_CUTOFF_DATE" />
                    <span v-else class="has-text-right is-pulled-right">
                      {{ formatDate(form.POPULATION_CUTOFF_DATE) }}
                    </span>
                    <span v-if="errPopulationCutOffDate" class="help is-danger">
                      {{ msgPopulationCutOffDate }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  ISP Multiplier
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      :readonly="!editCurrentPanel"
                      :disabled="editCurrentPanel"
                      type="text"
                      v-model="form.ISP_MULTIPLIER"
                      :aria-label="form.ISP_MULTIPLIER"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }">
                  ISP %
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      :readonly="!editCurrentPanel"
                      :disabled="editCurrentPanel"
                      type="text"
                      v-model="form.ISP_PERCENT"
                      :aria-label="form.ISP_PERCENT"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }">
                  Grace Year %
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      :readonly="!editCurrentPanel"
                      :disabled="editCurrentPanel"
                      type="text"
                      v-model="form.GRACE_YEAR_PERCENT"
                      :aria-label="form.GRACE_YEAR_PERCENT"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  CEP Current {{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:SCHOOL_YEAR`) }}
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      :readonly="!editCurrentPanel"
                      :disabled="editCurrentPanel"
                      type="text"
                      v-model="form.CEP_CURRENT_SCHOOL_YEAR"
                      :aria-label="form.CEP_CURRENT_SCHOOL_YEAR"
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
    <div
      v-if="editCurrentPanel"
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click.prevent="cancelPanel()"
        style="margin-right: 1rem"
      >
        Cancel
      </button>
      <button
        class="button is-primary"
        @click.prevent="updatePanel()"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    editOtherPanels: {
      type: Boolean,
    },
  },
  data() {
    return this.initialData();
  },
  async created() {
    await this.loadPersonTypes();
    this.initialize(this.properties);
    this.updateCache();
  },
  computed: {
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    ...mapActions({
      initProperties: 'propertiesModule/init',
    }),
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    cancelPanel() {
      this.undoForm();
      this.resetFormErrors();
      this.hideNotification();
      this.editCurrentPanel = false;
      this.$emit('allowEditOtherPanels');
    },
    checkField(field) {
      if (field === 'POPULATION_SUBMISSION_OPEN_DATE') {
        if (this.form.POPULATION_SUBMISSION_OPEN_DATE === '') {
          this.errPopOpenDate = true;
          this.msgPopOpenDate = '\'Population Submission Open Date\' is required.';
        } else if (this.form.POPULATION_SUBMISSION_OPEN_DATE >= this.form.POPULATION_SUBMISSION_DUE_DATE) {
          this.errPopOpenDate = true;
          this.msgPopOpenDate = '\'Population Submission Open Date\' must be before \'Population Submission Due Date\'';
        } else {
          this.errPopOpenDate = false;
          this.msgPopOpenDate = null;
        }
      }
      if (field === 'POPULATION_SUBMISSION_DUE_DATE') {
        if (this.form.POPULATION_SUBMISSION_DUE_DATE === '') {
          this.errPopDueDate = true;
          this.msgPopDueDate = '\'Population Submission Due Date\' is required.';
        } else if (this.form.POPULATION_SUBMISSION_DUE_DATE <= this.form.POPULATION_SUBMISSION_OPEN_DATE) {
          this.errPopDueDate = true;
          this.msgPopDueDate = '\'Population Submission Due Date\' must be after \'Population Submission Open Date\'';
        } else {
          this.errPopDueDate = false;
          this.msgPopDueDate = null;
        }
      }
      if (field === 'ELECTION_SUBMISSION_DUE_DATE') {
        if (this.form.ELECTION_SUBMISSION_DUE_DATE === '') {
          this.errElecDueDate = true;
          this.msgElecDueDate = '\'Elections Submission Due Date\' is required.';
        } else if (this.form.ELECTION_SUBMISSION_DUE_DATE <= this.form.POPULATION_SUBMISSION_DUE_DATE) {
          this.errElecDueDate = true;
          this.msgElecDueDate = '\'Elections Submission Due Date\' must be after \'Population Submission Due Date\'';
        } else {
          this.errElecDueDate = false;
          this.msgElecDueDate = null;
        }
      }
      if (field === 'ENROLLMENT_CUTOFF_DATE') {
        if (this.form.ENROLLMENT_CUTOFF_DATE === '') {
          this.errEnrollCutOffDate = true;
          this.msgEnrollCutOffDate = '\'Enrollment Cut-Off Date\' is required.';
        } else {
          this.errEnrollCutOffDate = false;
          this.msgEnrollCutOffDate = null;
        }
      }
      if (field === 'POPULATION_CUTOFF_DATE') {
        if (this.form.POPULATION_CUTOFF_DATE === '') {
          this.errPopulationCutOffDate = true;
          this.msgPopulationCutOffDate = '\'Population Cut-Off Date\' is required.';
        } else {
          this.errPopulationCutOffDate = false;
          this.msgPopulationCutOffDate = null;
        }
      }
    },
    checkForFormChanges() {
      return this.compareObjects(this.cache, this.form);
    },
    compareObjects(o, n) {
      return JSON.stringify(o) !== JSON.stringify(n);
    },
    editPanel() {
      this.editCurrentPanel = true;
      this.$emit('allowEditOtherPanels');
    },
    formHasErrors() {
      return this.errPopOpenDate
        || this.errPopDueDate
        || this.errElecDueDate
        || this.errEnrollCutOffDate
        || this.errPopulationCutOffDate;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }

      const dateParts = date.split('-');
      return `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
    },
    groupBySection(data, type) {
      return Object.entries(data)
        .filter(([key]) => key.includes(type))
        .map(([key, val]) => ({ [key.replace(type, '')]: val }));
    },
    initialize(data) {
      this.form = this.prepForDisplay('form', this.groupBySection(data, 'CEP-'));
    },
    initialData() {
      return {
        editCurrentPanel: false,

        cache: {},
        form: {},

        errPopOpenDate: false,
        errPopDueDate: false,
        errElecDueDate: false,
        errEnrollCutOffDate: false,
        errPopulationCutOffDate: false,

        msgPopOpenDate: null,
        msgPopDueDate: null,
        msgElecDueDate: null,
        msgEnrollCutOffDate: null,
        msgPopulationCutOffDate: null,

        percentageFields: [
          'ISP_PERCENT',
          'GRACE_YEAR_PERCENT',
        ],
      };
    },
    prepForDisplay(type, arrFromDb) {
      const o = {};
      arrFromDb.map((item) => {
        const key = Object.keys(item)[0];
        let value = item[key];
        if (this.percentageFields.includes(key) && value) {
          value *= 100;
        }
        o[key] = value;
        return 0;
      });
      return o;
    },
    prepForRequest() {
      const payload = [];
      let cached = null;
      let obj = null;
      let category = null;
      obj = this.form;
      cached = this.cache;
      category = 'CEP';
      Object.entries(obj).forEach(([property, value]) => {
        if (value !== cached[property]) {
          if (this.percentageFields.includes(property) && value) {
            const percentageValue = value / 100;
            payload.push({ category, property, percentageValue });
          } else {
            payload.push({ category, property, value });
          }
        }
      });
      return payload;
    },
    resetFormErrors() {
      this.errPopOpenDate = false;
      this.errPopDueDate = false;
      this.errElecDueDate = false;
      this.errEnrollCutOffDate = false;
      this.errPopulationCutOffDate = false;
      this.msgPopOpenDate = null;
      this.msgPopDueDate = null;
      this.msgElecDueDate = null;
      this.msgEnrollCutOffDate = null;
      this.msgPopulationCutOffDate = null;
    },
    showFormErrors(errors) {
      errors.forEach((e) => {
        if (e.property === 'POPULATION_SUBMISSION_OPEN_DATE') {
          this.errPopOpenDate = true;
          this.msgPopOpenDate = e.error;
        }
        if (e.property === 'POPULATION_SUBMISSION_DUE_DATE') {
          this.errPopDueDate = true;
          this.msgPopDueDate = e.error;
        }
        if (e.property === 'ELECTION_SUBMISSION_DUE_DATE') {
          this.errElecDueDate = true;
          this.msgElecDueDate = e.error;
        }
        if (e.property === 'ENROLLMENT_CUTOFF_DATE') {
          this.errEnrollCutOffDate = true;
          this.msgEnrollCutOffDate = e.error;
        }
        if (e.property === 'POPULATION_CUTOFF_DATE') {
          this.errPopulationCutOffDate = true;
          this.msgPopulationCutOffDate = e.error;
        }
      });
    },
    undoForm() {
      this.form = JSON.parse(JSON.stringify(this.cache));
    },
    updateCache() {
      this.cache = JSON.parse(JSON.stringify(this.form));
    },
    async updatePanel() {
      this.$emit('allowEditOtherPanels');
      const changes = this.checkForFormChanges();
      if (!changes) {
        this.editCurrentPanel = false;
        this.hideNotification();
        return;
      }
      if (this.formHasErrors()) {
        this.$emit('allowEditOtherPanels');
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        return;
      }
      try {
        await axios({
          method: 'put',
          url: '/properties',
          data: this.prepForRequest(),
        });
        this.updateCache();
        await this.initProperties();
        this.showNotification('success', ['The CEP Properties have been updated successfully.']);
        this.editCurrentPanel = false;
      } catch (error) {
        this.$emit('allowEditOtherPanels');
        if (error.response.status === 500) {
          this.showNotification('danger', ['Network Error.']);
        } else if (error.response.status === 400) {
          this.showFormErrors(error.response.data);
          this.showNotification('danger', ['There was an issue. Please try again or contact your administrator.']);
        } else {
          this.showNotification('danger', ['Something went wrong.']);
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
    &:first-child
      border: 0
      width: 30px
  a.disabled
    color: #999
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
  .property
    padding-left: 0
    font-size: 12px
    width: 60%
  .no-border
    border: 0
  // input[type="date"]::-webkit-inner-spin-button
  // input[type="date"]::-webkit-calendar-picker-indicator
  //   display: none
  //   -webkit-appearance: none
  .table-header-normal
    vertical-align: middle
</style>
